import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormControl} from '@angular/forms';
import {BaseModal} from '@ui-app/modals/base-modal';
import {BehaviorSubject} from 'rxjs';
import {map} from 'rxjs/operators';
import * as EmployeeModels from '@employee-models/index';
import {IRejectedReasonPayloadData} from '@employee-models/common.models';
import {StaticDataService} from '../../core/services/data-access/static-data-service';


interface IRejectedReasonsOptionsList extends EmployeeModels.DM.IRejectedPhotoReasonModel {
    isExcluded?: boolean;
    isChecked?: boolean;
}

@Component({
  selector: 'employee-photo-reject-modal',
  templateUrl: './photo-reject-modal.component.html',
  styleUrls: ['./photo-reject-modal.component.less']
})
export class PhotoRejectModalComponent extends BaseModal implements OnInit {


    @Input() buttonsTitle  = {
        dismiss: 'Cancel',
        confirm: 'Submit'
    };
    @Input() textAreaCharLimit = 200;


    reasonCharacterCounter$ = new BehaviorSubject<number>(0);
    reason: UntypedFormControl;
    rejectedReasons: IRejectedReasonsOptionsList[] = [];
    payload: IRejectedReasonPayloadData;
    checkedIds: Array<number>;
    isSubmitDisabled = true;

    constructor(private staticDataService: StaticDataService) {
        super();
    }

    ngOnInit(): void {
        this.fetchRejectPhotoReasons();
        this.initForm();
    }

    private initForm(): void {
        this.reason = new UntypedFormControl('');

        this.subs = this.reason.valueChanges
            .pipe(
                map(v => v ? v.length : 0),
            ).subscribe(this.reasonCharacterCounter$);
    }

    fetchRejectPhotoReasons(): void {
        const reasons = this.staticDataService.getRejectReasons();
        if (reasons.length) {
            reasons.forEach((value, index) => {
                this.rejectedReasons.push(value);
                this.rejectedReasons[index].isExcluded = false;
                this.rejectedReasons[index].isChecked = false;
            });
        }
    }

    pickRejectReason(reason: EmployeeModels.DM.IRejectedPhotoReasonModel): void {
        this.rejectedReasons.forEach(item => {
            if (item.rejectedPhotoReasonId === reason.rejectedPhotoReasonId) {
                item.isChecked = item.isChecked ? false : true;
            }
        });
        this.disableExcludedOptions();
        this.setCheckedItems();
    }

    getExcludedIdsSet(): Set<number> {
        const excludedIdsSet = new Set<number>();
        this.rejectedReasons.forEach(item => {
            if (item.isChecked && item.excludeIds.length) {
                item.excludeIds.forEach(id => excludedIdsSet.add(id));
            }
        });
        return excludedIdsSet;
    }

    disableExcludedOptions(): void {
        const excludedIdsSet = this.getExcludedIdsSet();
        this.rejectedReasons.forEach(item => {
            if (excludedIdsSet.has(item.rejectedPhotoReasonId)) {
                item.isExcluded = true;
            } else {
                item.isExcluded = false;
            }
        });
    }

    setCheckedItems(): void {
        this.checkedIds = [];
        this.rejectedReasons.forEach(item => {
            if (item.isChecked && !item.isExcluded) {
                this.checkedIds.push(item.rejectedPhotoReasonId);
            }
        });
        this.isSubmitDisabled = this.checkedIds.length ? false : true;
    }

    submit(): void {
        this.payload = {
            rejectedPhotoDetails: this.getAdditionalDetailsStr(this.reason.value),
            listRejectedPhotoReasonIds: this.checkedIds
        };
        this.action(this.payload);
    }

    getAdditionalDetailsStr(value: string): string | null {
        const trimmedStrLength = value.trim().length;
        return trimmedStrLength ? value : null;
    }

}
